import { Component, effect, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { Investisseur } from '@lib/models/generated/graphql';
import { DEFAULT_PAGINATION_PARAMS, PaginationParams } from 'finzzle-angular-utils';
import { OuiSearchbar } from 'omnium-ui/searchbar';
import { SHARED_IMPORTS } from 'projects/minotaure-lib/src/shared-imports';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AddRelationTableComponent } from '@lib/components/investisseur-details/tabs/connaissance-client/steps/situation-personnelle-step/add-update-relation-dialog/add-relation-table/add-relation-table.component';

@Component({
  selector: 'app-add-signataire',
  imports: [SHARED_IMPORTS, OuiSearchbar, AddRelationTableComponent],
  templateUrl: './add-signataire.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-signataire.component.scss',
})
export class AddSignataireComponent implements OnInit {
  public searchControl = new FormControl<string>('');
  public searchValue = signal<string | null>('');
  public selectedInvestisseurIds = input<number[] | undefined>([]);
  public investisseurs = input<Investisseur[]>([]);
  public addSignataire = output<Investisseur>();
  public requestResult: { loading: boolean; data: any } | undefined;
  public paginationParams: PaginationParams = DEFAULT_PAGINATION_PARAMS;
  public searchValueSig = toSignal(this.searchControl.valueChanges.pipe(debounceTime(100), distinctUntilChanged()), { initialValue: '' });

  public filteredInvestisseursEffect = effect(() => {
    const search = this.searchValueSig()?.toLowerCase() ?? '';
    const selectedIds = new Set(this.selectedInvestisseurIds() ?? []);
    const investisseurs = this.investisseurs();

    const result = investisseurs.filter(inv => {
      const id = inv.id as number;
      if (selectedIds.has(id)) return false;
      if (!search) return true;

      const personne = inv.personnePhysique[0];
      const nom = personne?.nom?.toLowerCase() ?? '';
      const prenom = personne?.prenom?.toLowerCase() ?? '';

      return nom.includes(search) || prenom.includes(search);
    });

    this.requestResult = {
      loading: false,
      data: {
        pageInfo: { hasNextPage: false, hasPreviousPage: false },
        items: result,
        totalCount: result.length,
      },
    };
  });

  ngOnInit(): void {
    this.initInvestisseurs();
  }

  private initInvestisseurs(): void {
    this.requestResult = {
      loading: false,
      data: {
        pageInfo: { hasNextPage: false, hasPreviousPage: false },
        items: this.investisseurs(),
        totalCount: this.investisseurs().length,
      },
    };
  }
}
